import {Component, Watch} from 'vue-property-decorator' ;
import {MemberViewModel} from './member.viewmodel' ;
import {namespace} from 'vuex-class' ;
import {
  PROFILE_MODULE_NAMESPACE,
  PROFILE_SET_MEMBER_BY_FIELD,
  PROFILE_GET_CIVILITY_LEGAL_FORM
} from '../../../../store/profile/profile-types.store';
import {BLOCK_MODULE_NAMESPACE, BLOCK_GET_BLOCKS_BYQUERY} from '../../../../store/block';
import {
  APARTMENT_MODULE_NAMESPACE,
  APARTMENT_GET_APPARTMENTS,
  APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE
} from '../../../../store/apartment';
import {ITeamMember} from '../../../../models/profile/member.model';
import {IApartmentParameter} from '../../../../models/apartment';
import {TICKET_MODULE_NAMESPACE, TICKET_GET_CHARACTER_PROBLEMS} from '../../../../store/ticket';
import {CrudStatus, SearchEntities} from '../../../../common/enums';
import {USER_MODULE_NAMESPACE} from '../../../../store/user/user-types.store';
import {IUser} from '../../../../models/user/user.model';
import {IUserDetails} from '../../../../models/user';
import {Validator} from '../../../../utils/Validator.util';
import {SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE} from "../../../../store/search";
import { UserTemplate } from '../../../../common/enums';
import { watch } from 'fs';


const ProfileStore = namespace(PROFILE_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)


@Component
class ProfileModalVertical extends MemberViewModel {

  dtRules: {
    lastNameRules?: any
    firstNameRules?: any
    addressRules?: any
    codePostalRules?: any
    cityRules?: any
    countryRules?: any
    rolesRules?: any
    civilityRules?: any
    emailRules?: any
    phoneRules?: any
    oldPasswordRules?: any
    newPasswordRules?: any
    passwordRules?: any
    companyRules?: any
  }

  dtBlocks: any[]
  dtApartments: any[]
  dtShowPassword: boolean

  dtIsValidCellphone: boolean
  dtIsValidLandline: boolean
  dtIsValidAddressLine: boolean
  dtIsChildAccount: boolean
  dtCompany: any[]
  dtSaveCurrentBlocksSelected: any[]
  dtCompanyParentRole: number[]
  dtSaveCurrentCompany: any[]
  dtCharPb2:any[]
  ticket_auto_add:boolean
  showPasswordField:boolean


  @BlockStore.Action(BLOCK_GET_BLOCKS_BYQUERY)
  storeGetBlocksByQuery: (query: string) => Promise<any>

  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS)
  storeGetAppartments: (payload: { blockId: number, merge: boolean, param: IApartmentParameter }) => Promise<any> | undefined

  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (payload?: any) => Promise<any>

  @TicketStore.Action(TICKET_GET_CHARACTER_PROBLEMS)
  storeGetCharacterProblems: () => Promise<any>

  @ProfileStore.Action(PROFILE_GET_CIVILITY_LEGAL_FORM)
  storeGetCivilityLegalForm: () => Promise<any>

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[], role?: number[]
  }) => Promise<any>;

  @ProfileStore.Mutation(PROFILE_SET_MEMBER_BY_FIELD)
  storeSetMemberByValue: (payload: ITeamMember) => void

  @ProfileStore.Getter entityRoles: any[]
  @ProfileStore.Getter civilities: { id: number, text: string }[]
  @ProfileStore.Getter member: ITeamMember
  @ProfileStore.Getter profileCrudActionStatus: CrudStatus
  @UserStore.Getter userCrudActionStatus: CrudStatus
  @UserStore.Getter user: IUser
  @UserStore.Getter userInfo: IUserDetails

  @TicketStore.Getter characterProblems: any;

  constructor() {
    super()

    this.dtRules = {}
    this.dtBlocks = []
    this.dtApartments = []

    this.dtIsValidCellphone = false
    this.dtIsValidLandline = false
    this.dtIsValidAddressLine = true
    this.dtShowPassword = false
    this.dtIsChildAccount = false
    this.dtCompany = []
    this.dtSaveCurrentBlocksSelected = []
    this.dtCompanyParentRole = null
    this.dtSaveCurrentCompany = []
    this.dtCharPb2 = []
    this.ticket_auto_add = false
    this.showPasswordField = false

  }


  @Watch('fake_email')
  fake_email_changed(val:boolean)
  {
    if(!this.isUpdateAction)
    {
      this.showPasswordField = val
    }
  }

  mounted() {

    /**
     * @description loading character problems options
     */
    this.storeGetCharacterProblems().then(()=>{
      if(this.isProfileUpdateAction)
      {
        // ==== preselected charProblem
        const preselectedCharPb1 = []
        this.member.char_pb.level_1.forEach(x=>preselectedCharPb1.push(x.id))
        this.charPb1 = preselectedCharPb1
        this.$nextTick(()=>{
          const preselectedCharPb2 = []
          this.member.char_pb.level_2.forEach(x=>preselectedCharPb2.push(x.id))
          this.charPb2 = preselectedCharPb2
          this.handleCharPb1Change(preselectedCharPb1)
        })
      }
    })

    /**
     * @description loading civilities legal forms
     */
    this.storeGetCivilityLegalForm()


    /**
     * @description setting form rules
     */

    this.dtRules = {
      lastNameRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.member_form.lastname)})
      ],
      firstNameRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.member_form.firstname)})
      ],
      rolesRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.member_form.role)})
      ],
      civilityRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.member_form.civility)})
      ],
      emailRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.member_form.email)}),
        v => /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) || this.$t(this.lblSetting.emailValid)
      ],
      oldPasswordRules: [
        //v => !v || ( Validator.isPasswordValid(v) || this.$t(this.lblSetting.passwordValid)),
        v => !v || (Boolean(this.newPassword) || this.$t(this.lblSetting.otherPasswordRequired, {type: this.$t(this.lblSetting.password_new)}))
      ],
      newPasswordRules: [
        //v => !v || (  v.length >= 8 || this.$t(this.lblSetting.passwordMin)),
        v => !v || ((Validator.isPasswordValid(v) && v.length >= 8) || this.$t(this.lblSetting.passwordValid)),
        v => !v || (Boolean(this.oldPassword) || this.$t(this.lblSetting.otherPasswordRequired, {type: this.$t(this.lblSetting.password_old)}))
      ],
      passwordRules: [
        v => !v || (v.length >= 8 || this.$t(this.lblSetting.passwordMin)),
        v => !v || (Validator.isPasswordValid(v) || this.$t(this.lblSetting.passwordValid))
      ],
      companyRules: [v => !!v || this.$t(this.lblSetting.companyRequired)]
    }

    if (this.isProfileUpdateAction) {

      if (this.member.blocks && this.member.blocks.length) {
        this.coBlocks = this.member.blocks
        this.storeSetMemberByValue({
          blocks: this.member.blocks.map(block => block.id),
          apartments: this.member.apartments.map(apartment => apartment.id)
        })

        this.handleBlockChange()
      }
      let memberRole = this.coRoles.filter(x => x.id === this.member.role)[0]
      this.ticket_auto_add = memberRole.ticket_auto_add
      if (memberRole.level && memberRole.level === 2)
        this.dtIsChildAccount = true
      this.dtSaveCurrentCompany = this.member.parent_entity ? [this.member.parent_entity] : []
      if (memberRole.fk_role_parent) {
        this.dtCompanyParentRole = [memberRole.fk_role_parent]
        this.handleGetCompany(null)
          .then(res => {
            this.coCompany = res
          })
      }
    }

    if (this.isUpdateAction) {
      this.dtIsValidLandline = true
      this.dtIsValidCellphone = true
    }
  }

  get lblSetting() {
    return {
      ...require('@/locales/profile').default,
      ...require('@/locales/ticket').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default
    }
  }


  get canManageUsersPassword(){
    return this.$route.meta['allow_update_user_password'] && this.$route.name !== 'profile-child'
  }

  get canUseFakeEmail()
  {
    return this.$route.meta['can_use_fake_email']
  }

  get showPasswordFieldLabel()
  {
    return this.isUpdateAction ? 'Modifier le mot de passe de l\'utilisateur' : 'Définir le mot de passe de l\'utilisateur'
  }

  get coCivilities() {
    return this.civilities
  }

  get coRoles() {
    if (this.$route.meta['manage_external_account']) return this.entityRoles.filter(x => x.id === 19)
    if(this.isServiceBookOwner) return this.entityRoles.filter(x => x.id !== 2 && x.id !== 3)
    return !this.$route.meta['manage_customer_account'] ? this.entityRoles.filter(x => x.id !== 1 && x.id !== 5) : this.entityRoles
  }

  get coBlocks() {
    return this.dtSaveCurrentBlocksSelected.concat(this.dtBlocks)
  }

  set coBlocks(value: any[]) {
    this.dtBlocks = value
  }

  get coApartments() {
    return this.dtApartments
  }

  set coApartments(value: any[]) {
    this.dtApartments = value.filter(item => !!item)
  }

  get coCompany() {
    return (this.dtSaveCurrentCompany || []).concat(this.dtCompany || [])
  }

  set coCompany(value: any[]) {
    this.dtCompany = value
  }

  get coCharacterProblems(): any[] {
    if (this.characterProblems.level_1.length) {
      const items:any[] = this.characterProblems.level_1
      return [...items.slice(1), items[0]]
    }

    return []
  }

  get coIsIntervenant(): boolean {
    return this.role === 4 || this.role === 10 || this.role === 19
  }

  get coIsExternalIntervenant(): boolean {
    return this.role === 4
  }

  get coIsValidOldPassword(): boolean {
    return Validator.isPasswordValid(this.oldPassword)
  }

  get coOldPasswordRules() {
    return this.coIsValidOldPassword && this.newPassword ? [] : this.dtRules.oldPasswordRules
  }

  get coIsValidNewPassword(): boolean {
    return Validator.isPasswordValid(this.newPassword) && this.newPassword.length >= 8
  }

  get coNewPasswordRules() {
    return this.coIsValidNewPassword && this.oldPassword ? [] : this.dtRules.newPasswordRules
  }

  get isUpdateAction(): boolean {
    return this.profileCrudActionStatus === CrudStatus.Update || this.userCrudActionStatus === CrudStatus.Update
  }

  get telDefaultCountry() {
    return (this.address && this.address.countryCode) || 'fr'
  }

  get isValidCellphone(): boolean {
    return !this.cellphone || (this.cellphone && this.dtIsValidCellphone)
  }

  get isValidLandline(): boolean {
    return !this.landline || (this.landline && this.dtIsValidLandline)
  }

  get isValidAddress(): boolean {
    return this.dtIsValidAddressLine
  }

  set isValidAddress(value: boolean) {
    this.dtIsValidAddressLine = value
  }

  onInputCellphone({number, isValid}) {
    this.cellphone = number
    this.dtIsValidCellphone = isValid
  }

  onInputLandline({number, isValid}) {
    this.landline = number
    this.dtIsValidLandline = isValid
  }

  get showSecondarySpecializationField(): boolean {
    return this.isUserUpdateAction && this.role === 4
  }

  get isProfileUpdateAction(): boolean {
    return this.profileCrudActionStatus === CrudStatus.Update
  }

  get isUserUpdateAction(): boolean {
    return this.userCrudActionStatus === CrudStatus.Update
  }
  get isServiceBookAgency():boolean {
    return this.userInfo.template === UserTemplate.serviceBookAgency
  }
  get isServiceBookOwner():boolean {
    return this.userInfo.template === UserTemplate.serviceBookOwner
  }
  passwordConcatRules(rules: any) {
    if (!this.dtRules.passwordRules) return []
    return [...this.dtRules.passwordRules, ...rules]
  }

  handleSearchChange(newVal: string) {
    if (newVal && newVal.length > 2) {
      this.storeGetBlocksByQuery(newVal)
        .then(response => {
          this.coBlocks = response
        })
        .catch(err => console.log('error fetching blocks options', err))
    }
  }

  async handleBlockChange(query?: string) {
    this.blocks.map(x => {
      if (this.dtSaveCurrentBlocksSelected.findIndex(y => y.id === x) === -1) {
        let blockToAdd = this.dtBlocks.find(y => y.id === x)
        if (blockToAdd) {
          this.dtSaveCurrentBlocksSelected.push(blockToAdd)
        }
      }
    })
    await this.handleFetchApartments(query)
  }

  handleCharPb1Change(value:any[])
  {
    if(this.charPb1.length)
    {
      this.dtCharPb2 = []
      this.charPb1.forEach(item=>{
        const selectedCharpb1 = this.coCharacterProblems.find(x=>x.id===item)
        if(selectedCharpb1)
        {
          this.dtCharPb2 = this.dtCharPb2.concat(selectedCharpb1.level_2)
        }
      })
      const newSelected = []
      this.dtCharPb2.map(item=>{
        if(this.charPb2 && this.charPb2.length)
        {
          if(this.charPb2.find(x=>x===item.id))
          {
            newSelected.push(item.id)
          }
        }
      })
      this.charPb2 = newSelected
    } else {
      this.dtCharPb2 = []
      this.charPb2 = []
    }
  }

  handleCharPb2Change(value)
  {
    //console.log("handleCharPb2Change:",value)
  }

  handleChangeCompany(val) {
    let newSaved = []
    if (this.dtSaveCurrentCompany.findIndex(y => y.id === this.parentEntity) === -1) {
      let contractorToAdd = this.coCompany.find(y => y.id === this.parentEntity)
      if (contractorToAdd) {
        newSaved.push(contractorToAdd)
      }
    }
    this.dtSaveCurrentCompany = newSaved
  }

  handleFetchApartments(query: string = '') {
    if (this.member.blocks && this.member.blocks.length)
      this.storeGetApartmentsAutocomplete({blockId: `${this.member.blocks.join()}`})
        .then(apartments => {
          this.coApartments = apartments.filter(apartment => !!apartment)
          this.storeSetMemberByValue({
            apartments: this.member.apartments.filter(apartment => {
              if (!this.coApartments || !this.coApartments.length) return false
              const apartmentOptionsIds: any = this.coApartments.map(item => item.id)
              return apartmentOptionsIds.includes(apartment)
            })
          })
        })
    else {
      this.storeSetMemberByValue({apartments: []})
      this.coApartments = []
    }
  }

  handleGetBlockAutocomplete(newVal: string, cb) {
    if (newVal && newVal.length > 2) {
      this.storeGetBlocksByQuery(newVal)
        .then(res => {
          cb((res || []).map(x => ({value: x.id, text: x.name, ...x})))
        })
        .catch(error => console.log(error))
    }
  }

  handleGetApartmentAutocomplete(newVal: string, cb?) {
    if (newVal && newVal.length >= 3) {
      this.storeGetApartmentsAutocomplete({key: newVal})
        .then(res => {
          cb((res || []).map(x => ({value: x.id, text: x.apartment_number, ...x})))
        })
        .catch(error => console.log(error))
    }

  }

  handleGetCompany(key: string) {
    return this.storeGetEntitySearch({
      role: this.dtCompanyParentRole,
      query: key,
      limit: 50
    })
  }

  handleIsChildAccount(value) {
    let selectedRole: any = this.coRoles.filter(x => x.id === value)[0]
    if (selectedRole.level === 2) {
      this.dtIsChildAccount = true
      if (selectedRole.fk_role_parent) {
        this.dtCompanyParentRole = [selectedRole.fk_role_parent]
        this.handleGetCompany(null)
          .then(res => {
            this.coCompany = res
          })
      }
    } else {
      this.dtIsChildAccount = false
    }
    this.ticket_auto_add = selectedRole.ticket_auto_add
  }
}

export default ProfileModalVertical



// WEBPACK FOOTER //
// ./src/containers/profile/components/profile-modal-vertical/index.ts